import { render, staticRenderFns } from "./WNavDropdown.vue?vue&type=template&id=b5252634&"
import script from "./WNavDropdown.vue?vue&type=script&lang=ts&"
export * from "./WNavDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports